import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { PropTableValues } from '../../src/components';
import { StatisticSizes, StatisticSpacingValues } from '@primer/react-brand';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {Statistic} from '@primer/react-brand'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Statistic>
  <Statistic.Heading>+25%</Statistic.Heading>
  <Statistic.Description>increase in developer speed</Statistic.Description>
</Statistic>
`}</code></pre>
    <h3>{`Boxed variant`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Statistic variant="boxed">
  <Statistic.Heading>+25%</Statistic.Heading>
  <Statistic.Description>increase in developer speed</Statistic.Description>
</Statistic>
`}</code></pre>
    <h3>{`Sizes`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <Statistic size="small">
    <Statistic.Heading>+25%</Statistic.Heading>
    <Statistic.Description>increase in developer speed</Statistic.Description>
  </Statistic>
  <br />
  <br />
  <Statistic size="medium">
    <Statistic.Heading>+25%</Statistic.Heading>
    <Statistic.Description>increase in developer speed</Statistic.Description>
  </Statistic>
  <br />
  <br />
  <Statistic size="large">
    <Statistic.Heading>+25%</Statistic.Heading>
    <Statistic.Description>increase in developer speed</Statistic.Description>
  </Statistic>
</>
`}</code></pre>
    <h3>{`Padding`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <Statistic padding="condensed">
    <Statistic.Heading>+25%</Statistic.Heading>
    <Statistic.Description>increase in developer speed</Statistic.Description>
  </Statistic>
  <br />
  <br />
  <Statistic padding="normal">
    <Statistic.Heading>+25%</Statistic.Heading>
    <Statistic.Description>increase in developer speed</Statistic.Description>
  </Statistic>
  <br />
  <br />
  <Statistic padding="spacious">
    <Statistic.Heading>+25%</Statistic.Heading>
    <Statistic.Description>increase in developer speed</Statistic.Description>
  </Statistic>
  <br />
  <br />
  <Statistic
    padding={{
      narrow: 'condensed',
      regular: 'normal',
      wide: 'spacious',
    }}
  >
    <Statistic.Heading>+25%</Statistic.Heading>
    <Statistic.Description>increase in developer speed</Statistic.Description>
  </Statistic>
</>
`}</code></pre>
    <h3>{`Accent descriptions`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Statistic>
  <Statistic.Heading>+25%</Statistic.Heading>
  <Statistic.Description variant="accent">
    increase in developer speed
  </Statistic.Description>
</Statistic>
`}</code></pre>
    <h3>{`Statistic`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom class on the root element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`Statistic.Heading`}</inlineCode>{`, `}<inlineCode parentName="td">{`Statistic.Description`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Content to be displayed within the component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`size`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={[...StatisticSizes]} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`'large'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The size of the Statistic`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`padding`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={[...StatisticSpacingValues]} commaSeparated mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`'none'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Adding padding to all internal sides of the component`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Statistic.Heading`}</h3>
    <p>{`Forwards all the props from the `}<a parentName="p" {...{
        "href": "/components/Heading"
      }}>{`Heading component`}</a>{`, including `}<inlineCode parentName="p">{`as`}</inlineCode>{`, `}<inlineCode parentName="p">{`size`}</inlineCode>{`, and `}<inlineCode parentName="p">{`weight`}</inlineCode>{`.`}</p>
    <h3>{`Statistic.Description`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`variant`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={['default', 'muted', 'accent']} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`'default'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Visual presentation of the component`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Forwards most props from the `}<a parentName="p" {...{
        "href": "/components/Text"
      }}>{`Text component`}</a>{`, including `}<inlineCode parentName="p">{`size`}</inlineCode>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      